/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Pagination1OfUserOrderRateReasonListedDto } from '../models/Pagination1OfUserOrderRateReasonListedDto';
import type { PostUserOrderRateReasonRequestAdmin } from '../models/PostUserOrderRateReasonRequestAdmin';
import type { PutUserOrderRateReasonRequestAdmin } from '../models/PutUserOrderRateReasonRequestAdmin';
import type { RateType } from '../models/RateType';
import type { UserOrderRateReasonAdminDto } from '../models/UserOrderRateReasonAdminDto';
import type { UserOrderRateReasonsClientDtoResponseClient } from '../models/UserOrderRateReasonsClientDtoResponseClient';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UserOrderRateReasonsService {
    /**
     * @returns UserOrderRateReasonsClientDtoResponseClient OK
     * @throws ApiError
     */
    public static getUserOrderRateReasonsClient({
        rateType,
        channelId,
    }: {
        rateType: RateType,
        channelId: number,
    }): CancelablePromise<UserOrderRateReasonsClientDtoResponseClient> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/userorderratereasons',
            query: {
                'rateType': rateType,
                'channelId': channelId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewUserOrderRateReasons`
     * @returns UserOrderRateReasonAdminDto OK
     * @throws ApiError
     */
    public static getUserOrderRateReasonAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<UserOrderRateReasonAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/userorderratereasons/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageUserOrderRateReasons`
     * @returns UserOrderRateReasonAdminDto OK
     * @throws ApiError
     */
    public static putUserOrderRateReasonAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutUserOrderRateReasonRequestAdmin,
    }): CancelablePromise<UserOrderRateReasonAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/userorderratereasons/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteUserOrderRateReasons`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteUserOrderRateReasonAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/userorderratereasons/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewUserOrderRateReasons`
     * @returns Pagination1OfUserOrderRateReasonListedDto OK
     * @throws ApiError
     */
    public static getUserOrderRateReasonsAdmin({
        id,
        minRate,
        maxRate,
        rateType,
        channelId,
        searchWord,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        id?: number,
        minRate?: number,
        maxRate?: number,
        rateType?: RateType,
        channelId?: number,
        searchWord?: string,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfUserOrderRateReasonListedDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/userorderratereasons',
            query: {
                'id': id,
                'minRate': minRate,
                'maxRate': maxRate,
                'rateType': rateType,
                'channelId': channelId,
                'searchWord': searchWord,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageUserOrderRateReasons`
     * @returns UserOrderRateReasonAdminDto Created
     * @throws ApiError
     */
    public static postUserOrderRateReasonAdmin({
        requestBody,
    }: {
        requestBody?: PostUserOrderRateReasonRequestAdmin,
    }): CancelablePromise<UserOrderRateReasonAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/userorderratereasons',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
